import { render, staticRenderFns } from "./SmtpServerForm.vue?vue&type=template&id=9ab188c2&scoped=true"
import script from "./SmtpServerForm.vue?vue&type=script&lang=js"
export * from "./SmtpServerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab188c2",
  null
  
)

export default component.exports